module.exports = __webpack_public_path__ + "static/chu-a3771c6388f37c31eab29d33f00f2fc5.png";